import {inject} from 'aurelia-framework';  
import {Router} from 'aurelia-router';
import {AuthService} from '../../services/authService';


@inject(AuthService, Router)
export class WhiteLabelSuspended {
    constructor(authService, router) {
        
        this.authService = authService;
        this.router = router;
      
     
    }

    activate() {
        this.contact_phone = window.contact_phone;
    }
    
}
